import {Dialog, DialogContent} from "@mui/material";
import React, {useCallback, useEffect, useState} from "react";
import Api from "../../../../common/Api";
import {ElementDto} from "../../../../common/apis/element/ElementDto";
import {hideMainPageOverlay} from "../../../MainPage";
import ElementDetailHeader from "./ElementDetailHeader";
import ElementDetailPanel from "./ElementDetailPanel";

interface IProps {
    initialElementId: string;
    opened: boolean;
    onClosed: (reload: boolean) => void;
    disableRelationshipActions?: boolean;
}

export default function ElementDetailDialog({opened, onClosed, initialElementId, disableRelationshipActions}: IProps) {

    const [elementDto, setElementDto] = useState<ElementDto>()
    const [elementId, setElementId] = useState<string>(initialElementId);
    const [updated, setUpdated] = useState<boolean>(false);

    const updateElementId = useCallback((newElementId: string) => setElementId(newElementId), []);

    useEffect(() => {
        if (initialElementId) {
            updateElementId(initialElementId);
            fetchElement(initialElementId);
        }
    }, [initialElementId, updateElementId]);

    function fetchElement(id: string) {
        Api.elements.getByIdentifier(id)
            .subscribe({
                next: (response) =>
                    setElementDto(response.response as ElementDto),
                error: () => {
                }
            })
    }

    function onClose() {
        hideMainPageOverlay();
        onClosed(updated);
        setElementDto(undefined);
        setUpdated(false);
    }

    return (
        <React.Fragment>
            {elementDto &&
                <Dialog open={opened}
                        aria-labelledby="item-detail-dialog"
                        onClose={onClose}
                        maxWidth={"xl"}>
                    <ElementDetailHeader element={elementDto}
                                         onClosed={onClose} />

                    <DialogContent>
                        <ElementDetailPanel id={elementId}
                                            key={elementId}
                                            onShowElementDetail={updateElementId}
                                            onUpdated={() => setUpdated(true)}
                                            onElementUpdated={fetchElement}
                                            disableRelationshipActions={disableRelationshipActions}
                        />
                    </DialogContent>
                </Dialog>
            }
        </React.Fragment>
    );

}
